import { IMeeting } from '../../resource/meeting/meeting.types';

export function initialBoardsPage(meetingId: IMeeting['id']) {
  console.log(meetingId);
}
